module.exports = __webpack_public_path__ + "static/media/1.785fd251.jpg";